import { RouteConfig } from "vue-router";

export const RCandidateTemplateDocumentsBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-documents-browse" */
      "./VTemplateDocumentsBrowse.vue"
    ),
};

export const RExpertTemplateDocumentsBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-documents-browse" */
      "./VTemplateDocumentsBrowse.vue"
    ),
};
